import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState, setUpdateQuizForm } from "./redux/slice";

export default function ThemeSelector({
  themes = [],
  themeData = [],
  isView = false,
}) {
  const dispatch = useDispatch();
  const { updateQuizForm, subThemes, selectedSubThemes } = useSelector(
    (state) => state.quizManagement,
  );

  // 🔹 Initialize from backend data (themeData)
  useEffect(() => {
    if (!themeData) return;

    // ✅ Support both array or single object
    const data = Array.isArray(themeData) ? themeData[0] : themeData;
    if (!data?.theme_id) return;

    // Find the matching theme
    const theme = themes.find((t) => t.theme_id === data.theme_id);
    if (!theme) return;

    // ✅ Set main theme
    dispatch(setUpdateQuizForm({ key: "themeId", value: theme.theme_id }));

    // ✅ Set available sub-themes from that theme
    dispatch(setState({ key: "subThemes", value: theme.sub_theme || [] }));

    // ✅ Preselect given sub_theme IDs (backend sends them as array of IDs)
    if (data.sub_theme && data.sub_theme.length > 0) {
      dispatch(setState({ key: "selectedSubThemes", value: data.sub_theme }));
    } else {
      dispatch(setState({ key: "selectedSubThemes", value: [] }));
    }
  }, [themeData, themes, dispatch]);

  // 🔹 On main theme change
  const handleThemeChange = (e) => {
    const themeId = Number(e.target.value);
    const selectedTheme = themes.find((t) => t.theme_id === themeId);

    dispatch(setUpdateQuizForm({ key: "themeId", value: themeId }));
    dispatch(setUpdateQuizForm({ key: "group_idd", value: [] }));
    dispatch(
      setState({ key: "subThemes", value: selectedTheme?.sub_theme || [] }),
    );
    dispatch(setState({ key: "selectedSubThemes", value: [] }));
  };

  // 🔹 On sub-theme checkbox toggle
  const handleSubThemeToggle = (id, isChecked) => {
    const updatedSubs = isChecked
      ? [...selectedSubThemes, id]
      : selectedSubThemes.filter((sid) => sid !== id);

    dispatch(setState({ key: "selectedSubThemes", value: updatedSubs }));
  };

  return (
    <div style={{ marginTop: "2%" }}>
      {/* Theme Selector */}
      <div className="row mb-3">
        <div className="row">
          <label className="col-sm-3 col-form-label font-medium text-gray-700">
            Themes
          </label>
          <div className="col-sm-9">
            <select
              disabled={isView}
              className="form-control"
              value={updateQuizForm.themeId || ""}
              onChange={handleThemeChange}
            >
              <option value="">-- Select Theme --</option>
              {themes.map((t) => (
                <option key={t.theme_id} value={t.theme_id}>
                  {t.name ?? `Theme ${t.theme_id}`}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Sub-Themes */}
      {updateQuizForm.themeId && subThemes?.length > 0 && (
        <>
          <div className="row mb-3">
            <div className="row">
              <label className="col-sm-3 col-form-label font-medium text-gray-700">
                Sub Themes
              </label>

              <div className="col-sm-9">
                <select
                  disabled={isView}
                  className="form-control"
                  value={selectedSubThemes[0] || ""}
                  onChange={(e) =>
                    dispatch(
                      setState({
                        key: "selectedSubThemes",
                        value: e.target.value ? [Number(e.target.value)] : [],
                      }),
                    )
                  }
                >
                  <option value="">-- Select Sub Theme --</option>

                  {subThemes.map((t) => (
                    <option key={t.theme_id} value={t.theme_id}>
                      {t.name ?? `Sub-theme ${t.theme_id}`}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
